import axios from 'axios'
import { BLOQUEAR_ITINERARIO_POR_CIDADE_EM_LOTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function bloquerItinerarioPorCidadeEmLote (parametros) {
  const url = `${URL}/itinerario/bloquear-itinerario-por-cidade-em-lote`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BLOQUEAR_ITINERARIO_POR_CIDADE_EM_LOTE,
        payload: response
      })
  );
}
